import z from 'zod';

const WorkspaceSchema = z.object({
  companyId: z.number().or(z.null()),
  companyName: z.string().or(z.null()),
  companyLogo: z.string().nullable(),
  isActive: z.boolean(),
  isActivated: z.boolean(),
  isEmployee: z.boolean(),
  isPinned: z.boolean(),
});

export const WorkspacesResponseSchema = z.array(WorkspaceSchema);

export type WorkspaceItem = z.infer<typeof WorkspaceSchema>;

export const TokensSchema = z.object({
  access: z.string(),
  accessExpiresIn: z.number(),
  refresh: z.string(),
  refreshExpiresIn: z.number(),
});

export const CompaniesSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
    brandsFiltration: z.boolean(),
    labelMatchingLogic: z.enum(['flexible', 'strict']),
  }),
);

export const CompanySchema = z.object({
  id: z.number(),
  name: z.string(),
  brandsFiltration: z.boolean(),
  labelMatchingLogic: z.enum(['flexible', 'strict']),
});

export const BrandsFiltrationRequestSchema = z.object({
  brandsFiltration: z.boolean(),
  labelMatchingLogic: z.enum(['flexible', 'strict']),
});

export const CampaignsResponseSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
  }),
);

export const MediaPlansResponseSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
  }),
);

export type MediaPlanType = z.infer<typeof MediaPlansResponseSchema>;
